<script setup lang="ts">
import { Info } from "lucide-vue-next";
import { Label } from "@/components/ui/label";
import { Tooltip } from "@/components/ui/tooltip";

withDefaults(
  defineProps<{
    label: string;
    hint?: string;
    inline?: boolean;
    nested?: boolean;
  }>(),
  { hint: "", inline: false, nested: false },
);
</script>

<template>
  <div :class="{ 'ml-2 border-l-2 border-border pl-3': nested }">
    <div
      class="flex items-center justify-between gap-3"
      :class="{ 'mb-1.5': !inline }">
      <div class="flex min-w-0 items-center gap-1.5">
        <Label class="truncate">{{ label }}</Label>
        <Tooltip
          v-if="hint"
          :content="hint"
          side="left">
          <Info class="size-3.5 shrink-0 text-muted-foreground hover:text-foreground" />
        </Tooltip>
      </div>
      <div
        v-if="inline"
        class="shrink-0">
        <slot />
      </div>
    </div>
    <slot v-if="!inline" />
  </div>
</template>
